export default function (phone) {
  phone = phone.replace(/\+7/g, '')
  phone = phone.replace(/\D+/g, '')
  return /[0-9]{10}/.test(phone)
}
